// extracted by mini-css-extract-plugin
export default {"ReferralEarnings_title-text":"referralEarnings_ReferralEarnings_title-text__JmN+G","ReferralEarnings_button_div":"referralEarnings_ReferralEarnings_button_div__4Rfmz"};